const activity = [
  {
    label: "Workover",
    value: "Workover",
  },
  {
    label: "Workover NPT",
    value: "Workover_NPT",
  },
  {
    label: "Drilling",
    value: "Drilling",
  },
  {
    label: "Drilling NPT",
    value: "Drilling_NPT",
  },
  {
    label: "Completion",
    value: "Completion",
  },
  {
    label: "Completion NPT",
    value: "Completion_NPT",
  },
  // {
  //     label:"Drilling DPR",
  //     value:"DPR"
  // }
];
export const options = {
  activity,
};

export const dashboardLinkList = {
  training: "Training Management",
  ohsc: "OHSE Review",
  incident: "Incident Management",
  capa: "CAPA Management",
  vfl: "Visible Felt Leadership",
  medical: "Health Management",
};
